export const EMPTY_LIST = Object.freeze([]);
export const EMPTY_OBJECT = Object.freeze({});
